import React from 'react';

const Hero = ({ onContactClick }) => {
  const handleContactClick = (e) => {
    e.preventDefault();
    onContactClick(e);
  };

  return (
    <section className="hero">
      <div className="glow glow-1"></div>
      <div className="glow glow-2"></div>
      <div className="hero-inner">
        <div className="hero-left">
          <div className="hero-tag">
            <div className="tag-pulse"></div>
            <span className="tag-text">AI Products · SaaS · Services · Consulting</span>
          </div>
          <h1>
            AI products built
            <span className="serif">for everyone.</span>
          </h1>
          <p className="hero-p">
            SSRR Labs designs and delivers intelligent software across
            finance, e-commerce, banking and human-centric applications.
            We build products that make a real difference — for businesses
            and for people.
          </p>
          <div className="hero-btns">
            <a href="#build" className="btn-g">
              Our Expertise
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </a>
            <a href="#contact" className="btn-outline" onClick={handleContactClick}>Start a Conversation</a>
          </div>
        </div>

        <div className="hero-panel">
          <div className="panel-box">
            <div className="panel-header">
              <div className="ph-dots">
                <div className="ph-dot" style={{ background: '#ff5f57' }}></div>
                <div className="ph-dot" style={{ background: '#febc2e' }}></div>
                <div className="ph-dot" style={{ background: '#28c840' }}></div>
              </div>
              <span className="ph-title">ssrrlabs.ai — product pipeline</span>
            </div>
            <div className="panel-body">
              <div className="p-card">
                <div className="pc-icon ic-fin">💳</div>
                <div style={{ flex: 1 }}>
                  <div className="pc-label">{"// "}FinTech</div>
                  <div className="pc-name">AI Financial Intelligence</div>
                  <div className="pc-bar"><div className="pc-fill" style={{ animationDelay: '0s' }}></div></div>
                </div>
              </div>
              <div className="p-card">
                <div className="pc-icon ic-eco">🛒</div>
                <div style={{ flex: 1 }}>
                  <div className="pc-label">{"// "}E-Commerce</div>
                  <div className="pc-name">Commerce Optimisation AI</div>
                  <div className="pc-bar"><div className="pc-fill" style={{ animationDelay: '0.4s' }}></div></div>
                </div>
              </div>
              <div className="p-card">
                <div className="pc-icon ic-bnk">🏦</div>
                <div style={{ flex: 1 }}>
                  <div className="pc-label">{"// "}Banking</div>
                  <div className="pc-name">Intelligent Banking Layer</div>
                  <div className="pc-bar"><div className="pc-fill" style={{ animationDelay: '0.8s' }}></div></div>
                </div>
              </div>
              <div className="p-card">
                <div className="pc-icon ic-hum">🧠</div>
                <div style={{ flex: 1 }}>
                  <div className="pc-label">{"// "}Human-Centric</div>
                  <div className="pc-name">Wellness & Life Intelligence</div>
                  <div className="pc-bar"><div className="pc-fill" style={{ animationDelay: '1.2s' }}></div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;